import gql from 'graphql-tag';

export const getProfileAvatar = gql`
  query GetProfileAvatar {
    viewer {
      _id
      profileAvatar {
        id
        image128Url
      }
    }
  }
`;
